import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';
import {getPaymentSessionId} from '../utils/helpers';

const getZepzPayinVerificationStatus = async ({
    requestId, sessionId, params, query
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const paymentSessionId = getPaymentSessionId(params, query);
    const {threeDSResult, redirectResult} = query;

    const loggerProps = {
        requestId, sessionId, paymentSessionId
    };

    logger.info('Retrieving Zepz Payin verification status', {
        eventId: eventIds['Retrieving Zepz Payin verification status'],
        ...loggerProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}/auth`, config.zepzPayinIntegrator.url);

        const verificationStatusResponse = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    redirectResult,
                    threeDSResult
                }
            })
        });

        throwOnResponseError(verificationStatusResponse);

        const verificationStatusData = await verificationStatusResponse.json();

        logger.info('Retrieved Zepz Payin verification status', {
            eventId: eventIds['Retrieved Zepz Payin verification status'],
            ...loggerProps,
            payload: verificationStatusData
        });

        return verificationStatusData;
    } catch (e) {
        const error = new Error(`Error retrieving Zepz Payin verification status: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Zepz Payin verification status'],
            ...loggerProps
        });

        throw error;
    }
};

export default getZepzPayinVerificationStatus;
